import styled from '@emotion/styled'
export const StyleWeekWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  justify-content: space-between;
`

export const StyleWeekDay = styled.div<any>`
  width: 60px;
  height: 50px;
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  border-radius: 4px;
  color: ${(props: any) =>
    props.theme.colors[props?.isActive ? 'white' : 'text']};
  background: ${(props: any) =>
    props.theme.colors[props?.isActive ? 'secondary' : 'white']};
  cursor: pointer;
`
